export default "__VITE_ASSET__DrByHwJA__"